const settings = {
  isSplash: true, // Changed to false as requested.
};

const seo = {
  title: "Esteban Ricardo Salazar | Portfolio",
  description: "A Data Science and AI enthusiast with a passion for leveraging technology to solve complex problems. Skilled in machine learning, NLP, and cloud services, aiming to make a significant impact in the tech industry.",
  og: {
    title: "Esteban Salazar Portfolio",
    type: "website",
    url: "http://estebansalazar.ml/",
  },
};

const greeting = {
  title: "Hello!",
  sub: "Esteban Ricardo Salazar",
  logo_name: "EstebanRicardoSalazar",
  resumeLink: "",
};

const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Github",
      iconifyClassname: "simple-icons:github",
      style: {
        color: "white",
      },
      profileLink: "https://github.com/butis498",
    },
    {
      siteName: "LinkedIn",
      iconifyClassname: "simple-icons:linkedin",
      style: {
        color: "#0077b5",
      },
      profileLink: "https://www.linkedin.com/in/butis498/",
    },
    // Removed other sites for brevity, add as necessary.
  ],
};

const skills = {
  data: [
    {
      title: "Programming Languages",
      fileName: "ProgrammingImg",
      skills: [
        "⚡ Proficient in SQL, C++, Python, and R for various programming and data analysis tasks.",
        "⚡ Experienced in applying Python for machine learning, data analysis, and web development projects.",
        "⚡ Capable of utilizing C++ for performance-critical applications and leveraging SQL for database management and manipulation.",
        "⚡ Skilled in R for statistical analysis and visualization.",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "logos-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "logos-c-plusplus",
          style: {
            backgroundColor: "transparent",
            color: "#00599C",
          },
        },
        {
          skillName: "SQL",
          fontAwesomeClassname: "logos-mysql",
          style: {
            backgroundColor: "transparent",
            color: "#F80000",
          },
        },
        {
          skillName: "R",
          fontAwesomeClassname: "fa-brands:r-project",
          style: {
            backgroundColor: "transparent",
            color: "#276DC3",
          },
        },
      ],
    },
    {
      title: "Frameworks & Libraries",
      fileName: "FrameworkImg",
      skills: [
        "⚡ Experienced with Pytorch and TensorFlow frameworks for developing machine learning and deep learning models.",
        "⚡ Capable of building, training, and deploying models with these frameworks to solve various AI challenges.",
      ],
      softwareSkills: [
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
            color: "#EE4C2C",
          },
        },
        {
          skillName: "TensorFlow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
            color: "#FF6F00",
          },
        },
      ],
    },
    {
      title: "Technical Skills",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Proficient in machine learning, data structures, algorithms, NLP, cloud processing, and deep learning for comprehensive data analysis and AI solution development.",
        "⚡ Skilled in data analysis and visualization, utilizing advanced techniques for insightful data interpretation.",
      ],
      softwareSkills: [
  {
    skillName: "Machine Learning",
    fontAwesomeClassname: "fa-solid:brain",
    style: {
      backgroundColor: "transparent",
      color: "#FFFF00",
    },
  },
  {
    skillName: "NLP",
    fontAwesomeClassname: "fa-language",
    style: {
      backgroundColor: "transparent",
      color: "#0073B1",
    },
  },
  {
    skillName: "Cloud",
    fontAwesomeClassname: "fa-cloud",
    style: {
      backgroundColor: "transparent",
      color: "#0000FF",
    },
  },
  {
    skillName: "Deep Learning",
    fontAwesomeClassname: "fa-solid:robot",
    style: {
      backgroundColor: "transparent",
      color: "#FF6F00",
    },
  },
],
    },
    {
      title: "Tools",
      fileName: "ToolsImg",
      skills: [
        "⚡ Experienced in utilizing Pandas for data manipulation and analysis in Python.",
        "⚡ Proficient in using Tableau for creating insightful data visualizations.",
        "⚡ Skilled in leveraging Azure cloud services for deploying and managing applications.",
        "⚡ Capable of using Docker for containerization, enabling efficient application deployment and scalability.",
      ],
      softwareSkills: [
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            backgroundColor: "transparent",
            color: "#150458",
          },
        },
        {
          skillName: "Tableau",
          fontAwesomeClassname: "simple-icons:tableau",
          style: {
            backgroundColor: "transparent",
            color: "#E97627",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "logos-microsoft-azure",
          style: {
            backgroundColor: "transparent",
            color: "#0089D6",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "logos-docker",
          style: {
            backgroundColor: "transparent",
            color: "#2496ED",
          },
        },
      ],
    },
  ],
};


const projectsHeader = {
  title: "Projects",
  description:
    "A showcase of projects demonstrating my expertise in leveraging AI and machine learning technologies to develop innovative solutions.",
};
const projectcards = {
  list: [
    {
      title: "Automatic Image Captioning for Medical Images",
      img_path: "medical_captioning.png",
      description: "Developed an advanced Multi-Modal Transformer Based Model for automatic caption generation for multi-view mammograms. This project combines CNNs, RNNs, and Transformers to process 40,000 mammogram reports, aiming for high diagnostic accuracy through sophisticated data preprocessing and feature integration.",
      tags: [
        { lang: "Python", color: "#3572A5" },
        { lang: "TensorFlow", color: "#FF6F00" },
        { lang: "NLP", color: "#F0DB4F" },
        { lang: "Azure", color: "#007FFF" },
      ],
    },
    {
      title: "NER in Mammography Radiology Reports",
      img_path: "ner_mammography.png",
      description: "This study leverages a multilingual transfer learning strategy for NER in mammography reports to enhance breast cancer diagnosis. Utilizing a comprehensive dataset from TecSalud, it aims to overcome linguistic barriers in medical documentation, fine-tuning NLP models for accuracy in identifying diagnostic features.",
      tags: [
        { lang: "Python", color: "#3572A5" },
        { lang: "PyTorch", color: "#EE4C2C" },
        { lang: "NLP", color: "#F0DB4F" },
        { lang: "Multilingual", color: "#B0B0B0" },
      ],
      code: "",
      link: "",
      linkcolor: "white",
    },
    {
      title: "EmpathAI - Advanced Chatbots for B2B",
      img_path: "empathai_chatbots.png",
      description: "EmpathAI revolutionizes B2B interactions with advanced chatbots that provide personalized, context-aware conversations using state-of-the-art NLP models. These chatbots are designed to understand and respond to complex business inquiries, enhancing customer service and engagement.",
      tags: [
        { lang: "Python", color: "#3572A5" },
        { lang: "React", color: "#61DAFB" },
        { lang: "LLMs", color: "#4B8BBE" },
        { lang: "Startup", color: "#E95420" },
      ],
      code: "",
      link: "https://ericka2319.hocoos.com",
      linkcolor: "white",
    },
    {
      title: "ParLanguage - Array Operations Made Easy",
      img_path: "parlanguage.png",
      description: "Par-language is a custom programming language designed to simplify array operations and fundamental programming concepts. With features like upfront variable declaration and efficient memory allocation for arrays, it offers a clear, concise syntax and robust error handling for a streamlined programming experience.",
      tags: [
        { lang: "Python", color: "#3572A5" },
        { lang: "YACC", color: "#F0DB4F" },
        { lang: "Compiler Design", color: "#007FFF" },
        { lang: "Array Operations", color: "#B0B0B0" },
      ],
      link:"",
      code: "https://github.com/Butis498/Par-Language",
      linkcolor: "white",
    },
  ],
};




const resumeleft = {
  left: {
    title: ["Experience"],
    data: [
      {
        title: "Data Scientist Researcher",
        subtitle: "Madrid",
        date: "Sep 2023 – Mar 2024",
        content: [
          "Conducted pioneering research in Natural Language Processing (NLP) to develop preprocessing scripts for images and text, streamlining the data preparation process for multi-modal AI models.",
          "Contributed to the development of a state-of-the-art multi-modal model, enhancing its ability to understand and process complex datasets involving both text and imagery.",
          "Published research findings in top-tier industry journals, establishing new benchmarks for NLP and image processing techniques.",
          "Engaged in collaborative projects with international research teams, broadening the scope of NLP applications and fostering global partnerships.",
        ],
      },
      {
        title: "AI Software Engineer",
        subtitle: "Kriptos, Quito",
        date: "Aug 2020 - Jun 2021",
        content: [
          "Led the improvement of data mobilization and storage mechanisms by optimizing code with Object-Oriented Programming (OOP) and SOLID principles, resulting in a 30% performance enhancement.",
          "Spearheaded the adoption of advanced machine learning models for enhanced data security and classification, significantly reducing false positives in sensitive data detection.",
          "Collaborated with cross-functional teams to integrate AI capabilities into broader software solutions, enhancing product offerings and customer satisfaction.",
          "Mentored junior engineers, fostering a culture of technical excellence and continuous learning within the team.",
        ],
      },
      {
        title: "Intern AI Software Engineer",
        subtitle: "Kriptos, Quito",
        date: "Jun 2020 – Aug 2020",
        content: [
          "Initiated and led a project to implement multiprocessing and multithreading in document processing workflows, boosting the efficiency of NLP operations by over 400%.",
          "Developed and optimized algorithms for document classification and summarization, significantly enhancing the productivity of the AI team.",
          "Contributed to the development of a proprietary NLP framework, laying the groundwork for scalable and efficient text analysis solutions.",
          "Received commendation for exceptional performance and innovation, resulting in a full-time offer post-internship.",
        ],
      },
    ],
  },
};

const resumeright = {
  right: [
    {
      title: ["Education"],
      data: [
        {
          title: "Masters in Computer Science",
          subtitle: "Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM), Monterrey",
          date: "Aug 2022 - Jun 2024",
          content: [
            "Full scholarship recipient.",
            "Current GPA: 96/100.",
            "Specializing in Artificial Intelligence and Machine Learning technologies.",
          ],
        },
        {
          title: "Bachelor of Software Engineering",
          subtitle: "Instituto Tecnológico y de Estudios Superiores de Monterrey (ITESM), Monterrey",
          date: "Aug 2017 - Dec 2021",
          content: [
            "Minor in Intelligent Systems.",
            "Graduated with a GPA of 91/100.",
            "Completed a capstone project on 'Automated Image Captioning with Deep Learning'.",
          ],
        },
      ],
    },
    {
      title: ["Languages"],
      data: [
        {
          title: "Spanish",
          content: ["Native proficiency."],
        },
        {
          title: "English",
          content: ["Professional working proficiency (B2)."],
        },
      ],
    },
    {
      title: ["Extra-Curricular Activities"],
      data: [
        {
          title: "Computer Science Tutor",
          subtitle: "Prepa-Tec, Monterrey",
          content: [
            "Provided tutoring in computer science basics, algorithms, and data structures to high school students.",
            "Developed interactive learning materials and exercises.",
          ],
        },
        {
          title: "Programming Tutor for Women",
          subtitle: "Women in Technology (WIT), Monterrey",
          content: [
            "Volunteered to support women entering technology fields through programming workshops.",
            "Organized sessions on Python programming and basic software development principles.",
          ],
        },
      ],
    },
  ],
};


const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "contact.jpg",
    description: "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, cloud services, and more.",
  },
  addressSection: {
    title: "Address",
    subtitle: "Monterrey, Mexico // Citizen of the world",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+528117861872", // Updated with your phone number.
  },
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/butis498",
    fontAwesomeIcon: "fa-github", // Use FontAwesome
    backgroundColor: "#FFFFFF",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/butis498/",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  // Add more social media links as necessary.
];



export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  projectsHeader,
  contactPageData,
  projectcards,
  resumeleft,
  resumeright,
};
